interface BadgeRowProps {
  image: string;
  alt: string;
  title: string;
  subtitle: string;
  row: string;
  titleColor: string;
  subtitleColor: string;
  shadow: string;
}

const BADGES: BadgeRowProps[] = [
  {
    image: "/badges/badge-silver.png",
    alt: "DFR silver badge",
    title: "Outstanding Analyst",
    subtitle: "top 15% in cohort",
    row: "border-[#DBDEE2] bg-[#F4F5F6]",
    titleColor: "text-[#6B727C]",
    subtitleColor: "text-[#9AA0A9]",
    shadow: "shadow-[0_4px_12px_rgba(124,131,141,.3)]",
  },
  {
    image: "/badges/badge-gold.png",
    alt: "DFR gold badge",
    title: "Exceptional Analyst",
    subtitle: "top 5% in cohort",
    row: "border-[#E4D3A1] bg-[#FBF6E7]",
    titleColor: "text-[#8A6D1F]",
    subtitleColor: "text-[#A08544]",
    shadow: "shadow-[0_4px_12px_rgba(138,109,31,.3)]",
  },
  {
    image: "/badges/badge-published-author.png",
    alt: "Published Author badge",
    title: "Published Author",
    subtitle: "featured in UK Investor Magazine",
    row: "border-[#EACDC8] bg-[#FBF0EE]",
    titleColor: "text-[#A41720]",
    subtitleColor: "text-[#B85B55]",
    shadow: "shadow-[0_4px_12px_rgba(164,23,32,.28)]",
  },
  {
    image: "/badges/badge-bug-buster.png",
    alt: "Bug Buster badge",
    title: "Bug Buster",
    subtitle: "report a new bug",
    row: "border-[#CBE3D2] bg-[#F0F8F2]",
    titleColor: "text-[#1E6F4F]",
    subtitleColor: "text-[#5C8A75]",
    shadow: "shadow-[0_4px_12px_rgba(30,111,79,.28)]",
  },
];

function BadgeRow({
  image,
  alt,
  title,
  subtitle,
  row,
  titleColor,
  subtitleColor,
  shadow,
}: BadgeRowProps) {
  return (
    <div className={`flex items-center gap-[13px] rounded-xl border px-3.5 py-[11px] ${row}`}>
      <img
        src={image}
        alt={alt}
        className={`h-[38px] w-[38px] flex-none rounded-full object-cover ${shadow}`}
      />
      <div className="flex min-w-0 flex-wrap items-baseline gap-x-2 gap-y-0">
        <span className={`text-sm font-extrabold tracking-[-.01em] ${titleColor}`}>{title}</span>
        <span className={`font-serif text-xs italic ${subtitleColor}`}>{subtitle}</span>
      </div>
    </div>
  );
}

export function BadgesUpForGrabs() {
  return (
    <div className="rounded-[14px] border border-content-border bg-card px-7 py-6">
      <div className="text-[11px] font-bold tracking-[.16em] text-content-muted">
        BADGES UP FOR GRABS
      </div>
      <div className="mt-4 flex flex-col gap-2.5">
        {BADGES.map((badge) => (
          <BadgeRow key={badge.title} {...badge} />
        ))}
      </div>
      <div className="mt-3.5 flex items-center gap-2.5">
        <span className="h-px w-[26px] flex-none bg-content-border" />
        <span className="font-serif text-[12.5px] italic text-content-muted">
          awarded on your relative feedback percentile
        </span>
      </div>
    </div>
  );
}
